<template>
  <bf-dialog :visible="show" :showClose='false' class="guid-wrap">
    <i class="dia-close" @click="show=false"><img src="./imgs/close_en.png"> </i>
    <div class="guid-con">
      <p class="title">{{$t('mt5event_101')}}</p>
      <p class="title" v-html="$t('mt5event_102')"></p>
      <router-link class="guid-btn" :to="{name:'mt5event'}">{{$t('mt5event_103')}}</router-link>
    </div>
  </bf-dialog>
</template>
<script>
// MT5交易大赛弹窗
export default {
  data () {
    return {
      show: false,
      timePeriod: [1586160000000, 1600016000000] // MT5比赛时间：2020/04/06 16:00-2020/04/10 16:00
    };
  },
  mounted () {
    this.isShow();
  },
  methods: {
    async isShow () {
      const now = Date.now();
      if (now >= this.timePeriod[0] && now <= this.timePeriod[1] && !window.localStorage.getItem('mt5event20200406')) {
        this.show = true;
        window.localStorage.setItem('mt5event20200406', 1);
      }
    }
  }
};
</script>
<style lang="scss" scoped>

.guid-wrap /deep/ {
  .bf-dialog {
    background-image: url("./imgs/bg_banner.png");
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 100% 100%;
    width: 680px !important;
    min-height: 400px;
    text-align: center;
    overflow: inherit !important;
    .guid-con {
      padding-top: 150px;
      > .title {
        font-size: 22px;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 27px;
        margin-bottom: 10px;
      }
      > .guid-btn {
        min-width: 230px;
        text-align: center;
        height: 44px;
        color: #000;
        font-size: 16px;
        line-height: 44px;
        background: rgba(240, 189, 66, 1);
        border-radius: 3px;
        display: inline-block;
        margin: 20px auto 5px;
      }
      > .tip {
        font-size: 12px;
        color: #fff;
        margin-top: 5px;
        > a {
          color: #14c393;
          vertical-align: bottom;
        }
      }
    }
    .dia-close {
      position: absolute;
      right: 0;
      top: 0;
      transform: translateX(60%) translateY(-60%);
      cursor: pointer;
    }
  }
}

</style>
